export default __webpack_public_path__ + "static/media/WildWater_07.15ea1efd.png";